import { Link } from "react-router-dom";
import { Box, FolderOpen, HelpCircle, Plus } from "lucide-react";

export const Logo = () => (
  <Link to="/" className="flex items-center gap-2 group" data-testid="nav-logo">
    <span className="h-7 w-7 rounded-lg bg-[#ff5a00] grid place-items-center transition-transform duration-300 group-hover:rotate-12">
      <Box size={15} className="text-white" strokeWidth={2.5} />
    </span>
    <span className="font-display font-extrabold text-[17px] tracking-tight whitespace-nowrap">Image2STL<span className="text-[#ff5a00]"> AI</span></span>
  </Link>
);

const NavBtn = ({ icon: Icon, label, onClick, id }) => (
  <button
    type="button"
    onClick={onClick}
    data-testid={id}
    className="flex items-center gap-1.5 px-3 h-8 rounded-lg text-[13px] text-zinc-300 hover:text-white hover:bg-white/5 transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#ff5a00]"
  >
    <Icon size={15} /> <span className="hidden sm:inline">{label}</span>
  </button>
);

export const TopNav = ({ onNew, onProjects, onHelp }) => (
  <header className="h-14 shrink-0 flex items-center justify-between px-4 border-b border-white/5 bg-[#0d0d0e]/95 backdrop-blur-xl z-20">
    <div className="flex items-center gap-3 sm:gap-6">
      <Logo />
      <nav className="flex items-center gap-1" aria-label="Workspace">
        <NavBtn icon={Plus} label="New project" onClick={onNew} id="nav-new-project-btn" />
        <NavBtn icon={FolderOpen} label="My projects" onClick={onProjects} id="nav-my-projects-btn" />
        <NavBtn icon={HelpCircle} label="Help" onClick={onHelp} id="nav-help-btn" />
      </nav>
    </div>
    <span className="text-[11px] font-semibold uppercase tracking-[0.15em] px-3 py-1 rounded-full border border-[#ff5a00]/40 text-[#ff7a33] bg-[#ff5a00]/10" data-testid="free-plan-indicator">
      Free<span className="hidden sm:inline"> plan</span>
    </span>
  </header>
);
